/**
* Allows displaying a summary of validation errors, with links to the corresponding fields. (To be used in conjuction with oly-form-validation-summary-display directive)
* Usage Example:
***************************************************************************************************************************
*  <oly-form-validation-summary-display></oly-form-validation-summary-display>
*  <form  name= "myForm" oly-form-validation-summary ng-submit=blah() >
*      <input id = "myForm-Firstname" name = "FirstName" ngModel="FirstNameModel" />
*  </form
********************************************************************************************************************************
* Note that the id of the input Fields should be "<input id="formName" name="formName">" for the links to work.
* If the id of the input field has periods in it, the last value after a period will be used (eg: <input id="formName" name="ctrl.formName"> will use formName as the form name. name="ctrl.form.name" will use name as the form name)
* Also note that validity for the input field needs to be "false" for it to display in the summary. Server errors will explicitly need to have validity set to false for the corresponding field.
*/
const $ = require('jquery');
const _ = require('lodash');

module.exports = function (olyFormValidationSummaryService, $timeout) {
    return {
        restrict: 'A',
        require: 'form',
        link(scope, element, attrs, formCtrl) {
            olyFormValidationSummaryService.clearAllValidationErrors();

            function getFormName() {
                if (formCtrl.$name.indexOf('.') > 0) {
                    const fields = formCtrl.$name.split('.');
                    return fields.length > 1 ? fields[fields.length - 1] : fields[0];
                }
                return formCtrl.$name;
            }

            const formName = getFormName();

            const generateValidationSummary = function () {
                $timeout(function () {
                    let isAtLeastOneFieldInvalid = false;
                    _.forEach(formCtrl, (value, field) => {
                        let key;
                        let isValueInErrorList;
                        if (formCtrl[field]) {
                            key = formName + '-' + formCtrl[field].$name; //get unique id of the element

                            if (formCtrl[field].$invalid) {
                                isAtLeastOneFieldInvalid = true;

                                isValueInErrorList = $.inArray(key, olyFormValidationSummaryService.validationErrors()) >= 0;

                                if (!isValueInErrorList) {
                                    olyFormValidationSummaryService.validationErrors()[key] = { name: formCtrl[field].$name, id: key };
                                }
                            } else {
                                olyFormValidationSummaryService.markToDelete(key);
                            }
                        }
                    });

                    olyFormValidationSummaryService.clearAllMarked();

                    //Force form invalid to be false to enable adding other validation errors on submit
                    if (isAtLeastOneFieldInvalid) {
                        formCtrl.$invalid = false;
                    }
                });
            };

            scope.$watch(
                function () { return formCtrl.$submitted; },
                function (newValue) {
                    if (newValue === true) {
                        olyFormValidationSummaryService.focusSummary = true;
                        generateValidationSummary();
                    }
                });

            scope.$watch(
                function () { return formCtrl.$invalid && !formCtrl.$pristine && formCtrl.$submitted; },
                function (newValue) {
                    if (newValue === true) {
                        generateValidationSummary();
                    }
                });

            scope.$watch(
                function () { return formCtrl.$valid; },
                function (newValue, oldValue) {

                    if (newValue === true && oldValue === false) {
                        olyFormValidationSummaryService.clearFormValidationErrors(formName);

                        //Set form invalid to false.
                        formCtrl.$invalid = false;
                    }
                });

            element
                .off('click.validationSummary')
                .on('click.validationSummary', 'input[type=submit], button[type=submit]', function () {
                    olyFormValidationSummaryService.focusSummary = true;
                });

            scope.$on('$destroy', function () {
                olyFormValidationSummaryService.clearFormValidationErrors(formName);
            });
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/form-validation-summary/form-validation-summary-directive.js
 **/